export default "__VITE_ASSET__a9d20430__"